import React, { useLayoutEffect, useRef, useState, useEffect } from 'react'
import {
    Navbar,
    NavbarBrand,
} from 'reactstrap';
import "../../layout.css"

const GuestHeader = () => {
    const headerRef = useRef(null);
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        return localStorage.getItem('Language') || 'RS'; // Default to Serbian for guests
    });
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

    useLayoutEffect(() => {
        // Koristimo useLayoutEffect umesto useEffect za DOM manipulaciju
        if (headerRef.current) {
            headerRef.current.style.visibility = 'visible';
            headerRef.current.style.opacity = '1';
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('Language', selectedLanguage);
        window.dispatchEvent(new CustomEvent('languageChange', {
            detail: { selectedLanguage }
        }));
    }, [selectedLanguage]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 576);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <React.Fragment>
            <Navbar
                ref={headerRef}
                expand="xl"
                style={{
                    backgroundColor: "#163B3D",
                    borderBottomLeftRadius: isMobile ? 10 : 18,
                    borderBottomRightRadius: isMobile ? 10 : 18,
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: isMobile ? '45px' : '70px',
                    paddingTop: '2px',
                    paddingBottom: '2px',
                }}
            >
                {/* Logo - truly centered relative to entire page */}
                <NavbarBrand style={{ 
                    position: 'absolute', 
                    left: '50%', 
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <img src="/assets/img/FORUM26-green.png" className='logo' style={{ marginLeft: 0 }} />
                </NavbarBrand>

                {/* Language selector in the right corner */}
                <div style={{
                    position: 'absolute',
                    right: isMobile ? '8px' : '14px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <div className='d-flex justify-content-center align-items-center' style={{ cursor: 'pointer' }}>
                        <span
                            onClick={() => setSelectedLanguage('RS')}
                            className={`me-2 language-selector ${selectedLanguage === 'RS' ? 'language-selected' : ''}`}
                            style={{ cursor: 'pointer', color: selectedLanguage === 'RS' ? '#fff' : '#ccc', fontSize: isMobile ? '10px' : '13px' }}
                        >
                            RS
                        </span>
                        <span className="language-selector" style={{ color: '#ccc', fontSize: isMobile ? '10px' : '13px' }}>|</span>
                        <span
                            onClick={() => setSelectedLanguage('EN')}
                            className={`ms-2 language-selector ${selectedLanguage === 'EN' ? 'language-selected' : ''}`}
                            style={{ cursor: 'pointer', color: selectedLanguage === 'EN' ? '#fff' : '#ccc', fontSize: isMobile ? '10px' : '13px' }}
                        >
                            EN
                        </span>
                    </div>
                </div>
            </Navbar>
        </React.Fragment>
    )
}

export default GuestHeader